import React from 'react';
import PageSection from '../components/layout/PageSection';
import Navbar from '../components/Navbar';

const projects = [
  {
    title: "LAN ANSADE",
    description: "Mise en place d'un réseau local pour l'Agence Nationale de la Statistique et de la Démographie",
    logo: "/images/ansad.png",
    category: "Réseau"
  },
  {
    title: "LAN IPN",
    description: "Déploiement d'un réseau local pour l'Institut de la Presse Numérique",
    logo: "/images/ipn.jpg",
    category: "Réseau"
  },
  {
    title: "LAN SUPNUM",
    description: "Installation d'un réseau local pour l'École Supérieure du Numérique",
    logo: "/images/supnum.png",
    category: "Réseau"
  },
  {
    title: "INTERCONNEXION DES RÉSEAUX DE SOMELEC",
    description: "Interconnexion des différents réseaux de la Société Mauritanienne d'Électricité",
    logo: "/images/somelek.webp",
    category: "Infrastructure"
  }
];

const Portfolio = () => {
  return (
    <div className="min-h-screen">
      <Navbar />
      
      {/* Hero Section with Background Image */}
      <section className="relative h-[85vh] overflow-hidden">
        <div className="absolute inset-0 w-full h-full">
          <img
            src="/images/R.jpg"
            alt="Portfolio Background"
            className="w-full h-full object-cover filter brightness-100 contrast-110 saturate-110"
            loading="eager"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-transparent to-black/20"></div>
        </div>
      </section>

      {/* Projects Section with Decorative Background */}
      <section className="relative py-16 bg-gradient-to-br from-green-50 via-white to-green-100">
        {/* Decorative Background Elements */}
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute top-0 left-0 w-64 h-64 bg-green-200/20 rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 right-0 w-64 h-64 bg-green-300/20 rounded-full blur-3xl"></div>
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-green-100/20 rounded-full blur-3xl"></div>
        </div>

        <div className="container mx-auto px-4 relative z-10">
          <h3 className="text-4xl font-bold mb-12 text-center text-green-800">Nos Projets</h3>
          <p className="text-xl text-center text-gray-600 mb-12">Explorez notre portfolio de réalisations</p>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-6xl mx-auto">
            {projects.map((project, index) => (
              <div 
                key={index}
                className="bg-white/90 backdrop-blur-sm rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden border border-green-100 transform hover:-translate-y-1"
              >
                <div className="p-8">
                  <div className="flex items-center space-x-6 mb-6">
                    <div className="w-20 h-20 flex-shrink-0 bg-white rounded-xl p-2 shadow-md">
                      <img 
                        src={project.logo} 
                        alt={project.title} 
                        className="w-full h-full object-contain"
                      />
                    </div>
                    <div>
                      <h3 className="text-2xl font-bold text-green-800 mb-2">{project.title}</h3>
                      <span className="inline-block px-4 py-1.5 text-sm font-semibold text-green-600 bg-green-50 rounded-full border border-green-100">
                        {project.category}
                      </span>
                    </div>
                  </div>
                  <p className="text-gray-600 leading-relaxed">{project.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Portfolio; 